export default `---
slug: precision-manufacturing
title: "Precision Manufacturing Probing"
year: 2019
category: university
featured: false
tags: [MATLAB, CMM, Manufacturing, Simulation]
thumbnail: /images/projects/3_mad_at_matlab.png
description: "Simulating CMM inspection and measurement uncertainty for precision manufacturing — the project I hated, aced anyway, and bonded over with my team."
relatedLinks:
  - label: "Bachelor at Politecnico di Milano"
    href: /career/bachelor-polimi
---

![Coding at night](/images/projects/3_mad_at_matlab.png)

I *hated* this project, and the class in general.
It was the "Computer Aided Manufacturing" class, the topics were too many, the professor was awful, and we had to commute all the way to Bovisa for an 8 am class...
In the project, with virtually zero instructions and support, we had to design the production cycle of a metallic piece, and then simulate the inspection of the piece to ensure the precision of the manufacturing process.
In my team — with Edoardo *(get used to this name, he'll be around...)*, Luca Colombo and Laura Ortensio from Valtellina with Love — I was responsible for the second part, for which I report below the instructions verbatim:

## Inspection Project

The groups will describe the procedure for the inspection of the part described ISO 10791-7:1998, large version on a CMM. This requires the following steps:

- Suggest an adequate positioning and fixturing
- Propose an adequate CMM and probe
- Define the probe configuration (stylus length, tip diameter etc.)
- Choose the mathematical alignment
- Plan the measurement strategy (number and location of sampling points, probe path, probing sequence, etc.)
- In case any tolerance will not be inspected, motivate the reason for the exclusion

For a single geometric tolerance, the students will have to estimate the measurement uncertainty provided by the chosen strategy by simulation, and state whether this uncertainty is adequate or not to verify the conformance to the tolerance itself. The selected tolerance is the perpendicularity tolerance of the central hole to datum plane A.

Basically I had to make this stupid simulation in MatLab (very stupid language), with virtually no instructions.
Thankfully commarade spirit grew in the class, and all the team started working together to find a solution to the problem, and then we all used that solution.
The most annoying part of all, is that all this effort and stress was worth virtually nothing at the exam — *which I still aced cuz in uni I was a beast*
`;
